// src/components/EditTask.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    Box,
    Paper,
    Grid,
    TextField,
    Button,
    MenuItem,
    IconButton
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL || '';

// Komponent pobierający użytkowników i wyświetlający select
const UsersSelect = ({ value, onChange }) => {
    const [users, setUsers] = useState([]);
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_URL}/api/users`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setUsers(response.data);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, []);

    return (
        <TextField
            select
            fullWidth
            label="Przydzielony do"
            name="assigned_to"
            value={value}
            onChange={onChange}
            required
        >
            {users.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                    {user.username} ({user.email})
                </MenuItem>
            ))}
        </TextField>
    );
};

// Funkcja konwertująca datę do formatu YYYY-MM-DD wymaganym przez input type="date"
const convertDateToInputFormat = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const EditTask = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [task, setTask] = useState(null);
    const [form, setForm] = useState({
        title: '',
        description: '',
        service_type: '',
        priority: '',
        status: '',
        due_date: '',
        assigned_to: ''
    });

    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/tasks/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setTask(response.data);
                setForm({
                    title: response.data.title,
                    description: response.data.description,
                    service_type: response.data.service_type,
                    priority: response.data.priority,
                    status: response.data.status,
                    due_date: convertDateToInputFormat(response.data.due_date),
                    // Przypisany użytkownik jako string, aby pasował do wartości selecta
                    assigned_to: response.data.assigned_to ? String(response.data.assigned_to) : ''
                });
            } catch (error) {
                console.error('Error fetching task:', error);
            }
        };
        fetchTask();
    }, [id, token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`${API_URL}/api/tasks/${id}`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate('/tasks');
        } catch (error) {
            console.error('Error updating task:', error);
        }
    };

    if (!task) {
        return <Typography>Ładowanie zadania...</Typography>;
    }

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h4" gutterBottom>Edycja zadania</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Tytuł"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Opis"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Typ usługi"
                                    name="service_type"
                                    value={form.service_type}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Priorytet"
                                    name="priority"
                                    value={form.priority}
                                    onChange={handleChange}
                                    required
                                >
                                    {[1, 2, 3, 4, 5].map(num => (
                                        <MenuItem key={num} value={num}>
                                            {num}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Status"
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="pending">pending</MenuItem>
                                    <MenuItem value="in_progress">in_progress</MenuItem>
                                    <MenuItem value="completed">completed</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Data wykonania"
                                    name="due_date"
                                    type="date"
                                    value={form.due_date}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <UsersSelect
                                    value={form.assigned_to}
                                    onChange={(e) => setForm({ ...form, assigned_to: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    Zapisz zmiany
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default EditTask;